import axios from './config';
import { cleanContent } from '../lib/editor-embed';

const list = (params, successCb, errorCb) => {
  axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/articles`, { params },
  ).then(
    res => successCb(res.data),
  ).catch(
    err => errorCb(err),
  );
};

const get = (id, successCb) => {
  axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/article/${id}`,
  ).then(
    res => successCb(res.data),
  ).catch(
    err => console.error('api.articles.get() received error from api request:', err),
  );
};

const post = (params, successCb, errorCb) => {
  let { article } = params;

  if (article.content && article.content.trim()) {
    article.content = cleanContent(article.content);
  }

  axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/article`,
    article,
  ).then(
    res => successCb(res.data),
  ).catch(
    errorCb,
  );
};

const put = (params, successCb, errorCb) => {
  let { article } = params;

  if (article.content && article.content.trim()) {
    article.content = cleanContent(article.content);
  }

  axios.put(
    `${process.env.REACT_APP_API_BASE_URL}/article/${params.id}`,
    article,
  ).then(
    res => successCb(res.data),
  ).catch(
    errorCb,
  );
};

const endpoints = {
  list,
  get,
  post,
  put,
};

export default endpoints;